import { apiProvider } from './api';
import { NAME } from './constants';
import { router } from './router';

export const NahradniSazbaLakovaci = {
	name: NAME,
	apiProvider,
	router,
};
